import React from 'react'

const SuccessMark = require('../../assets/success-mark.svg')
const styles = require('./registration-success.module.scss')

export const RegistrationSuccess: React.FC = () => (
    <div className={styles.container}>
        <div className={styles.centered}>
            <img src={SuccessMark} alt="Success" />
            <p id="successText" className={styles.text}>Регистрация <br />прошла успешно!</p>
        </div>
    </div>
)
